import { FormattedMessage } from 'react-intl'

import Card from '@10xLabs/react-web/components/Card'
import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { Header, Title, Content, Table, Th, Tr, Td } from '../TopList'

export const TopCompanies = ({ companies }: TSFixMe): TSFixMe => {
  return (
    <Card.Container>
      <Header>
        <Title>
          <FormattedMessage id="sites.dashboard.topCompanies.label" defaultMessage="Top Companies" />
        </Title>
      </Header>

      <Content>
        <Table>
          <thead>
            <tr>
              <Th>
                <FormattedMessage id="sites.dashboard.topCompanies.name" defaultMessage="Name" />
              </Th>

              <Th>
                <FormattedMessage id="sites.dashboard.topCompanies.sales" defaultMessage="Sales" />
              </Th>

              <Th>
                <FormattedMessage id="sites.dashboard.topCompanies.gross" defaultMessage="Gross" />
              </Th>
            </tr>
          </thead>

          <tbody>
            {companies.map((company: TSFixMe, index: TSFixMe): TSFixMe => {
              return (
                <Tr key={index}>
                  <Td>{company.name}</Td>

                  <Td>
                    <FormattedNumber value={company.count} />
                  </Td>

                  <Td>
                    <FormattedPrice value={company.amount} />
                  </Td>
                </Tr>
              )
            })}
          </tbody>
        </Table>
      </Content>
    </Card.Container>
  )
}
